export default __webpack_public_path__ + "static/media/GMX.6509d69b.png";